export const WelcomeSrc=
`# Welcome to Beansite XP
### The New and Improved Ultimate Bean Playground
***
Afer months of hard work, I am super proud and excited to present to you, the new Beansite. Boasting a completly new codebase written from scratch, a Node.js backend, and usage of React, Redux, and Vite to make this project as fast and efficient as possible. The new beansite relies on an advanced SDK that have meticulously developed over the span of multiple months.`